import { all, takeLatest } from 'redux-saga/effects';

import { getGuides } from './getGuides';
import * as actionTypes from '../actionTypes';

export default function* watchGuides() {
    yield all([takeLatest(actionTypes.FETCH_GUIDES, getGuides)]);
}
